import React from 'react'

const Header = ({title}) => {
  return (
    <div className='navHeading'>
        <span className='title'>{title}</span>
    </div>
  )
}

export default Header
